import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { HELPING_FAMILIES } from "../../data";
import { Reveal } from "./Reveal";

export const HelpingFamilies = () => (
  <section id="helping-families" data-testid="helping-families-section" className="relative py-24 md:py-32 bg-[#0a192f] border-y border-[#bf953f]/10 overflow-hidden">
    <div className="absolute -bottom-1/4 -right-1/4 h-[55vh] w-[55vh] rounded-full bg-[#1a4b9b]/14 blur-[160px] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-6">
        <Reveal>
          <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">How We Help Families</p>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-white">
            Walking with you, <span className="text-gold-gradient italic">every step.</span>
          </h2>
        </Reveal>
        {HELPING_FAMILIES.paragraphs.map((p, i) => (
          <Reveal key={i} delay={0.1 + i * 0.06}>
            <p className={`mt-5 font-body font-light leading-relaxed ${i === 0 ? "text-white/75 text-lg" : "text-white/60 text-base md:text-lg"}`}>
              {p}
            </p>
          </Reveal>
        ))}
        <Reveal delay={0.24}>
          <ul className="mt-7 space-y-3">
            {HELPING_FAMILIES.points.map((pt) => (
              <li key={pt} className="flex items-start gap-3 font-body text-sm md:text-base text-white/70">
                <Check size={17} className="mt-0.5 shrink-0 text-[#d4af37]" />
                {pt}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-9 flex flex-wrap gap-4">
            <Link
              to="/services"
              data-testid="helping-families-services-btn"
              className="btn-sweep inline-flex items-center rounded-full bg-gold-metallic px-7 py-3 font-body text-sm font-medium tracking-wide text-black"
            >
              Explore Our Protection
            </Link>
            <Link
              to="/contact"
              data-testid="helping-families-contact-btn"
              className="inline-flex items-center rounded-full border border-[#bf953f]/40 px-7 py-3 font-body text-sm tracking-wide text-white/80 hover:text-[#fcf6ba] hover:border-[#d4af37] transition-colors duration-300"
            >
              Start a Conversation
            </Link>
          </div>
        </Reveal>
      </div>

      <Reveal className="lg:col-span-6" delay={0.12}>
        <div className="relative">
          <div className="absolute -inset-3 rounded-3xl border border-[#bf953f]/25" />
          <div className="relative overflow-hidden rounded-3xl">
            <motion.img
              initial={{ scale: 1.1 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              src={HELPING_FAMILIES.image}
              alt="Family walking together in the sunlight on a beach"
              data-testid="helping-families-image"
              className="h-[380px] md:h-[500px] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
